//atom
'use client';

import React from 'react';

import {Input as MUIInput} from '@mui/material';
import {InputProps as Props} from './Input.type';

import './Input.scss';

/**
 * Atomic Input component from MUI
 */
export const Input = React.forwardRef(function Input(
  {className, ...props}: Props,
  ref
) {
  const inputClassName = ` input-base ${className}`;
  return (
    <MUIInput
      ref={ref}
      disableUnderline
      {...props}
      className={inputClassName}
    />
  );
});
